// extracted by mini-css-extract-plugin
export var activityContainer = "_lu-0";
export var typingIndicatorContainer = "_lu-1";
export var typingIndicatorDot = "_lu-2";
export var wave = "_lu-3";